export default __webpack_public_path__ + "static/media/ogbanner.b873ed37.jpg";